import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=933da95c"
import script from "./Clause.vue?vue&type=script&lang=ts"
export * from "./Clause.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports